/* global __VERSION__ */
import React from 'react';
import { Box } from '../../layout';

const Footer = () => (
  <Box direction="row"
       justifyContent="flex-end"
       alignItems="center"
       tag="footer" className="theme-background">
    Version: {__VERSION__}
  </Box>
);

export default Footer;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/Footer/index.js